import {BenchmarkOption, FrontEndTelehealthFlag} from '../../shared/enums';
import {
  BenchmarkHelperObject,
  BenchmarkType,
  extendedBenchmarkOptions,
  originalBenchmarkOptions
} from '../../shared/benchmark-types';
import {MetricType} from '../../shared/metric-types';

export enum MpeDialogPage {
  NONE,
  SETUP,
  SUMMARY,
  CLOSED,
  EXPORTED
}

export interface SchedulePane {
  reportName: string;
  isMonthly: boolean;
}

export interface BenchmarkCombo {
  option: BenchmarkOption;
  percentile?: BenchmarkType;
}

export function getBenchmarkComboDefault(showExtendedBenchmarks: boolean, telehealthFlag: FrontEndTelehealthFlag): BenchmarkCombo {
  return {
    percentile: BenchmarkType.Mean,
    option: showExtendedBenchmarks ? getDefaultBenchmarkOptionForTelehealthFlag(telehealthFlag) : BenchmarkOption.Academic
  };
}

function getDefaultBenchmarkOptionForTelehealthFlag(telehealthFlag: FrontEndTelehealthFlag): BenchmarkOption {
  switch (telehealthFlag) {
    case FrontEndTelehealthFlag.ALL_VISIT_TYPES:
      return BenchmarkOption.Academic;
    case FrontEndTelehealthFlag.IN_PERSON:
      return BenchmarkOption.InPersonAcademic;
    case FrontEndTelehealthFlag.TELEHEALTH:
      return BenchmarkOption.TelehealthAcademic;
  }
}

export function determineBenchmarkOptions(metric: MetricType): BenchmarkHelperObject[] {
  switch (metric) {
    case MetricType.NewPatientVisits:
    case MetricType.EandM:
    case MetricType.EandMTrend:
    case MetricType.OverviewNpv:
    case MetricType.OverviewEandM:
      return extendedBenchmarkOptions;
    default:
      return originalBenchmarkOptions;
  }
}

export function getBenchmarkOptionPlaceHolder(option: BenchmarkOption, benchmarkOptions: BenchmarkHelperObject[]): string {
  const benchmarkOption = benchmarkOptions.find(o => o.value === option);
  return benchmarkOption?.name || '';
}

export interface BatchExportScheduleResponse {
  batchExportScheduleDetails: BatchExportSchedule[];
}

export interface BatchExportSchedule {
   reportName: string;
   nodePath: string;
   dateRangeOption: number;
   scheduleType: number;
   startDateInMonths: number;
   endDateInMonths: number;
   isMarkedForDelete: boolean;
   payerCategoryKey: number;
   payerKey: number;
   payerType: number;
   lagKey: number;
   invoiceStatus: number;
   isOutpatientRequired: boolean;
   isInPatientRequired: boolean;
   isEmergencyMedicineRequired: boolean;
   isOpthalmologyRequired: boolean;
   billingAreaKey: number;
   telehealthFlag: number;
   isOverviewRequired: boolean;
   isEmPageRequired: boolean;
   isEmPageOutpatientRequired: boolean;
   isEmPageInPatientRequired: boolean;
   isEmPageEmergencyMedicineRequired: boolean;
   isEmPageOpthalmologyRequired: boolean;
   isNewPatientVisitsTrendPageRequired: boolean;
   memberLocationKeys: string;
   isEmTrendPageRequired: boolean;
   emTrendRangeNewPatientVisit: boolean;
   emTrendRangeEstablishedPatientVisit: boolean;
   emTrendRangeConsultation: boolean;
   emTrendRangeInitialHospital: boolean;
   emTrendRangeSubsequentHospital: boolean;
   emTrendRangeHospitalDischarge: boolean;
   emTrendRangeEmergencyMedicine: boolean;
   emTrendRangeNpvEyeExam: boolean;
   emTrendRangeEstablishedEyeExam: boolean;
}

